module.exports = __webpack_public_path__ + "img/validate.a9357de2.svg";